export enum EDocumentsExtensions {
    PDF = 'PDF',
    XLSX = 'XLSX',
    CSV = 'CSV',
    DOCX = 'DOCX',
}

export const REPORT_GENERATION_PARAMETERS_CARD_MESSAGE = 'Сформировать отчет с примененными фильтрами?';
export const REPORT_GENERATION_PARAMETERS_CARD_TITLE = 'Параметры формирования отчета';
